import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";
import { CURRENT_PROJECTS } from "../data/content";

export const CurrentProjects = () => (
  <section data-testid="current-projects-section" className="bg-ink py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeader eyebrow="Currently Building" title="On Site, Right Now">
        A behind-the-scenes look at the homes taking shape across Nassau & Suffolk County.
      </SectionHeader>

      <div className="mt-16 space-y-px border-y border-white/10">
        {CURRENT_PROJECTS.map((project, i) => (
          <Reveal key={project.name} delay={0.08 * i}>
            <article
              data-testid={`current-project-${i}`}
              className="group grid gap-8 border-b border-white/10 py-10 last:border-b-0 md:grid-cols-12 md:items-center"
            >
              <div className="relative overflow-hidden md:col-span-4">
                <img
                  src={project.image}
                  alt={`${project.name} construction progress`}
                  loading="lazy"
                  className="aspect-[16/10] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                />
                <span
                  className="absolute left-4 top-4 flex items-center gap-2 bg-black/70 px-3 py-1.5 font-accent text-[10px] font-semibold uppercase tracking-[0.2em] text-gold backdrop-blur-sm"
                  data-testid={`current-project-status-${i}`}
                >
                  <span className="relative flex h-1.5 w-1.5" aria-hidden="true">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-gold opacity-75" />
                    <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-gold" />
                  </span>
                  {project.status}
                </span>
              </div>
              <div className="md:col-span-6">
                <span className="font-accent text-[11px] font-medium uppercase tracking-[0.25em] text-gray-500">
                  {project.type} — {project.location}
                </span>
                <h3 className="mt-3 font-serif text-2xl font-medium text-white md:text-3xl">{project.name}</h3>
                <p className="mt-4 max-w-xl text-sm leading-relaxed text-gray-400">{project.description}</p>
              </div>
              <div className="md:col-span-2 md:text-right">
                <a
                  href="#contact"
                  data-testid={`current-project-link-${i}`}
                  aria-label={`Ask about ${project.name}`}
                  className="inline-flex items-center gap-2 font-accent text-xs font-semibold uppercase tracking-[0.25em] text-gold transition-colors duration-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-gold"
                >
                  View Project
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" />
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
